// Clawback rules sagas — mirrors the commission rules saga, with the extra
// symbols fetch.

import { put, select } from 'redux-saga/effects';
import * as types from '../../lib/actionTypes.es6';
import * as actions from './actions.es6';
import {
  makeWatcher,
  makeLatestWatcher,
  makeDebouncedWatcher
} from '../../components/CommissionsShared/makeWatcher.es6';
import {
  getClawbackRules,
  getClawbackRule,
  createClawbackRule,
  updateClawbackRule,
  validateClawbackRule,
  getClawbackRuleSymbols
} from '../../lib/requests.es6';

export var VALIDATE_DEBOUNCE_MS = 600;

export var getClawbackRulesRequestWatcher = makeLatestWatcher(
  types.GET_CLAWBACK_RULES_REQUEST,
  getClawbackRules,
  actions.getClawbackRulesSuccess,
  actions.getClawbackRulesFailed
);

export var getClawbackRuleRequestWatcher = makeLatestWatcher(
  types.GET_CLAWBACK_RULE_REQUEST,
  getClawbackRule,
  actions.getClawbackRuleSuccess,
  actions.getClawbackRuleFailed,
  {
    args: function(payload) {
      return [payload && payload.guid ? payload.guid : payload];
    }
  }
);

// Every filter is optional, so an empty params object is a valid "show all"
// refresh rather than a request to suppress.
function* refreshRuleList() {
  var params = yield select(function(state) {
    var slice = state.clawbackRules;
    return (slice && slice.listParams) || {};
  });
  yield put(actions.getClawbackRulesRequest(params));
}

export var createClawbackRuleRequestWatcher = makeWatcher(
  types.CREATE_CLAWBACK_RULE_REQUEST,
  createClawbackRule,
  actions.createClawbackRuleSuccess,
  actions.createClawbackRuleFailed,
  { onSuccessEffects: refreshRuleList }
);

export var updateClawbackRuleRequestWatcher = makeWatcher(
  types.UPDATE_CLAWBACK_RULE_REQUEST,
  updateClawbackRule,
  actions.updateClawbackRuleSuccess,
  actions.updateClawbackRuleFailed,
  {
    args: function(payload) { return [payload.guid, payload.body || payload]; },
    onSuccessEffects: refreshRuleList
  }
);

export var validateClawbackRuleRequestWatcher = makeDebouncedWatcher(
  types.VALIDATE_CLAWBACK_RULE_REQUEST,
  VALIDATE_DEBOUNCE_MS,
  validateClawbackRule,
  actions.validateClawbackRuleSuccess,
  actions.validateClawbackRuleFailed
);

// Cached in the slice: the builder asks once and reuses it for autocomplete and
// for treating those names as defined during chain validation.
export var getClawbackSymbolsRequestWatcher = makeLatestWatcher(
  types.GET_CLAWBACK_SYMBOLS_REQUEST,
  getClawbackRuleSymbols,
  actions.getClawbackSymbolsSuccess,
  actions.getClawbackSymbolsFailed,
  { args: function() { return []; } }
);
